import { Injectable } from '@angular/core'
import { WebService } from '../api/web.service'
import { Observable, map } from 'rxjs'
import { Store } from '@ngrx/store'
import { ServiceUrlConstants } from 'src/constants/service-url-constants'
import { AppState } from 'src/store/state/app.state'
import { DashboardInfoAPIModel } from 'src/models/api.model'
import { getDashboardBankingInfo } from 'src/store/selector/dashboard.selector'

@Injectable({
  providedIn: 'root'
})
export class DashboardService {
  constructor(private webservice: WebService, private appState: Store<AppState>) {}

  getDashboardInfoFromStore = (): Observable<DashboardInfoAPIModel> => {
    return this.appState.select(getDashboardBankingInfo())
  }

  callGetDashboardInfoApi = () => {
    return this.webservice
      .get(ServiceUrlConstants.API_GET_DASHBOARD_INFO)
      .pipe(map((data: DashboardInfoAPIModel) => data))
  }
}
